module.exports = __webpack_public_path__ + "static_pc/img/3.1c256f09.jpeg";